import type React from 'react';
import type { FC } from 'react';

import type { AriaProps } from '@iconik-io/shared-lib/src/react/a11y/aria';

import IconButton from '../../../icon_button/icon_button';

import styles from './clear_button.module.css';

type Props = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  aria?: AriaProps;
};

const ClearButton: FC<Props> = ({ onClick, aria }) => (
  <IconButton
    className={styles.button}
    onClick={onClick}
    iconName="close"
    aria={aria}
  />
);

export default ClearButton;
